var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    [
      _c("PageHeader", { attrs: { title: _vm.title, items: _vm.items } }),
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: { title: "import devices" },
          on: {
            show: _vm.resetModal,
            hidden: _vm.resetModal,
            ok: _vm.handleOk
          },
          scopedSlots: _vm._u([
            {
              key: "modal-ok",
              fn: function(ref) {
                return [_vm._v("Sure")]
              }
            },
            {
              key: "modal-cancel",
              fn: function(ref) {
                return [_vm._v("Close")]
              }
            }
          ]),
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c(
            "form",
            {
              ref: "form",
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.handleSubmit($event)
                }
              }
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Select brand:",
                    "label-cols-sm": "4",
                    "label-align-sm": "right",
                    "label-for": "device-brand"
                  }
                },
                [
                  _c("b-form-select", {
                    attrs: { id: "device-brand", options: _vm.types.brand },
                    model: {
                      value: _vm.form.brandId,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "brandId", $$v)
                      },
                      expression: "form.brandId"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-group mb-0" },
                [
                  _c("input", {
                    staticClass: "filestyle",
                    staticStyle: {
                      position: "absolute",
                      clip: "rect(0px, 0px, 0px, 0px)"
                    },
                    attrs: {
                      type: "file",
                      "data-input": "false",
                      id: "filestyle-1",
                      tabindex: "-1"
                    },
                    on: {
                      change: function($event) {
                        return _vm.upload($event)
                      }
                    }
                  }),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Upload file:",
                        "label-cols-sm": "4",
                        "label-align-sm": "right",
                        "label-for": "device-file"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "group-span-filestyle",
                          attrs: { tabindex: "0", "b-col": "8" }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "btn btn-secondary",
                              staticStyle: { "margin-bottom": "0" },
                              attrs: { for: "filestyle-1" }
                            },
                            [
                              _c("span", { staticClass: "buttonText" }, [
                                _vm._v("upload Excel file")
                              ])
                            ]
                          ),
                          _c("p", [_vm._v("only support xls、xlxs file")])
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Remarks:",
                    "label-cols-sm": "4",
                    "label-align-sm": "right",
                    "label-for": "remarks"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "remarks",
                      placeholder: "Maximum 20 characters",
                      oninput:
                        "if(value.length > 20)value = value.slice(0, 20)",
                      trim: ""
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Device NO.",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "device-number"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "device-number", trim: "" },
                                model: {
                                  value: _vm.search_condition.deviceNumber,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "deviceNumber",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.deviceNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Device Brand",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "device-brand"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "device-brand",
                                  options: _vm.types.brand
                                },
                                model: {
                                  value: _vm.search_condition.brandId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "brandId",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.brandId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Active Time",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "active-time"
                              }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  format: "MM/DD/YYYY",
                                  range: "",
                                  "append-to-body": "",
                                  lang: "en",
                                  placeholder: "Select date"
                                },
                                model: {
                                  value: _vm.activeTime,
                                  callback: function($$v) {
                                    _vm.activeTime = $$v
                                  },
                                  expression: "activeTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Device Model",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "device-model"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "device-model",
                                  options: _vm.types.deviceList
                                },
                                model: {
                                  value: _vm.search_condition.deviceModelId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "deviceModelId",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.deviceModelId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Device Status",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "device-status"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "device-status",
                                  options: _vm.types.statuss
                                },
                                model: {
                                  value: _vm.search_condition.status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "status",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.search()
                                }
                              }
                            },
                            [_vm._v("Search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-card",
                [
                  _c(
                    "b-button-group",
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "deviceList::Import",
                              expression: "'deviceList::Import'"
                            }
                          ],
                          attrs: { variant: "info" },
                          on: {
                            click: function($event) {
                              _vm.modalShow = !_vm.modalShow
                            }
                          }
                        },
                        [_vm._v("Import")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "table-responsive mb-0" },
                    [
                      _c("b-table", {
                        ref: "table",
                        attrs: {
                          "show-empty": "",
                          "empty-text": "no records",
                          id: "table",
                          "head-variant": "light",
                          busy: _vm.isBusy,
                          striped: true,
                          items: _vm.provider,
                          fields: _vm.fields,
                          "per-page": _vm.search_condition.pageSize,
                          "current-page": _vm.search_condition.pageNum,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          filter: _vm.filter,
                          "filter-includedfields": _vm.filterOn
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-danger my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _c("strong", [_vm._v("Loading...")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(index)",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.index +
                                        (_vm.search_condition.pageNum - 1) *
                                          _vm.search_condition.pageSize +
                                        1
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button-group",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "has",
                                            rawName: "v-has",
                                            value: "deviceList::Details",
                                            expression: "'deviceList::Details'"
                                          }
                                        ],
                                        staticClass: "mr-1",
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.show(
                                              row.item,
                                              row.index,
                                              $event.target
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Details")]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "has",
                                            rawName: "v-has",
                                            value:
                                              "deviceList::Release Binding",
                                            expression:
                                              "'deviceList::Release Binding'"
                                          }
                                        ],
                                        staticClass: "mr-1",
                                        attrs: {
                                          size: "sm",
                                          variant: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.releaseBinding(
                                              row.item,
                                              row.index,
                                              $event.target
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Release Binding")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "dataTables_paginate paging_simple_numbers float-right"
                          },
                          [
                            _vm.rows != 0
                              ? _c(
                                  "ul",
                                  { staticClass: "pagination mb-0" },
                                  [
                                    _c("b-pagination", {
                                      attrs: {
                                        "per-page": 10,
                                        "total-rows": _vm.rows,
                                        "aria-controls": "table"
                                      },
                                      model: {
                                        value: _vm.search_condition.pageNum,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.search_condition,
                                            "pageNum",
                                            $$v
                                          )
                                        },
                                        expression: "search_condition.pageNum"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }